<template>
  <div>
    <label v-if="label" style="font-size: 14px;display:block;margin-bottom: 5px;">{{ label }}</label>
    <div class="upload-container" :class="className">
      <div class="upload-box" :class="{ active: this.imageUrl }" @click="triggerFileInput">
        <!-- Tanda "+" saat belum ada gambar -->
        <div v-if="!imageUrl" class="upload-placeholder">
          <span class="material-symbols-outlined">
            photo_camera
          </span>
        </div>

        <!-- Loading animation saat file diupload -->
        <div v-if="loading" class="loading-overlay">
          <div class="spinner"></div>
        </div>

        <!-- Menampilkan gambar setelah upload -->
        <img v-if="imageUrl" :src="imageUrl" alt="Uploaded Image" class="uploaded-image" />

        <!-- Tombol hapus jika gambar sudah ada -->
        <button v-if="imageUrl" @click.stop="removeImage" class="remove-btn">Hapus</button>

        <!-- File input tersembunyi -->
        <input ref="fileInput" type="file" @change="handleFileChange" hidden accept="image/*" />
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet } from '@/api';

export default {
  data() {    
    return {
      siswa: this.$store.state.siswa.data,
      loading: false,
      imageUrl: null,
      file: null,
    };
  },
  props: {
    filename: String,
    className: String,
    endpoint: String,
    url: String,
    label: String
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.file = file;
      this.loading = true;

      try {
        const fixFileName = [this.filename, this.siswa.id, this.siswa.nama_lengkap].join('_').toLowerCase().replace(/[^a-zA-Z0-9_]/g, '_');

        // minta signed URL ke backend
        const res = await apiGet(`/v1/public/generate-spaces-url?filename=${fixFileName}&type=${file.type}`);
        const { uploadUrl, publicUrl } = await res;

        // upload langsung ke DigitalOcean Spaces
        await fetch(uploadUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type, "x-amz-acl": "public-read" },
          body: file
        });

        this.imageUrl = publicUrl; // simpan URL publik
        this.$emit("uploaded", this.imageUrl);
      } catch (error) {
        console.error("Upload failed:", error);
      } finally {
        this.loading = false;
      }
    },

    removeImage() {
      this.imageUrl = null;
      this.file = null;
    },
  },
  mounted() {
    if (this.url) {
      this.imageUrl = this.url
    }
  }
};
</script>

<style scoped>
.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;

  &.invalid {
    .upload-box {
      border: 1px dashed #f00;
    }
  }
}

.upload-box {
  position: relative;
  width: 100%;
  height: 60px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    border: 1px dashed #999;
  }

  &:active {
    background: #f7f7f7;
  }

  &.active {
    height: auto;
    padding: 15px 0;
  }
}

.plus-sign {
  font-size: 24px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.spinner {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.uploaded-image {
  max-width: 70%;
  max-height: 100%;
  object-fit: cover;
}

.remove-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 8px 12px;
  background-color: rgba(255, 0, 0, 0.7);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;
}

.remove-btn:hover {
  background-color: red;
}
</style>